import checkeredBackground from './checkeredBackground'
import computedMaxCroppingLeft from './computedMaxCroppingLeft'
import computedMaxCroppingTop from './computedMaxCroppingTop'
import computedMaxScaling from './computedMaxScaling'
import computedMinCroppingLeft from './computedMinCroppingLeft'
import computedMinCroppingTop from './computedMinCroppingTop'
import computedMinScaling from './computedMinScaling'
import croppingLeft from './croppingLeft'
import croppingTop from './croppingTop'
import relativeRotatedInternalImageHeight from './relativeRotatedInternalImageHeight'
import relativeRotatedInternalImageWidth from './relativeRotatedInternalImageWidth'
import rotatedInternalImageHeight from './rotatedInternalImageHeight'
import rotatedInternalImageWidth from './rotatedInternalImageWidth'
import scaledRotatedInternalImageHeight from './scaledRotatedInternalImageHeight'
import scaledRotatedInternalImageHeightDifference from './scaledRotatedInternalImageHeightDifference'
import scaledRotatedInternalImageWidth from './scaledRotatedInternalImageWidth'
import scaledRotatedInternalImageWidthDifference from './scaledRotatedInternalImageWidthDifference'
import scaling from './scaling'
import oversamping from './oversampling/'

export default {
  checkeredBackground,
  computedMaxCroppingLeft,
  computedMaxCroppingTop,
  computedMaxScaling,
  computedMinCroppingLeft,
  computedMinCroppingTop,
  computedMinScaling,
  croppingLeft,
  croppingTop,
  relativeRotatedInternalImageHeight,
  relativeRotatedInternalImageWidth,
  rotatedInternalImageHeight,
  rotatedInternalImageWidth,
  scaledRotatedInternalImageHeight,
  scaledRotatedInternalImageHeightDifference,
  scaledRotatedInternalImageWidth,
  scaledRotatedInternalImageWidthDifference,
  scaling,
  ...oversamping,

  stuff () {
    const {
      _dirtyOriginLeft,
      _dirtyOriginTop,
      _dirtyScaling,
      dirtyOriginLeft,
      dirtyOriginTop,
      dirtyScaling
    } = this
    return {
      dirtyOriginLeft: dirtyOriginLeft === _dirtyOriginLeft,
      dirtyOriginTop: dirtyOriginTop === _dirtyOriginTop,
      dirtyScaling: dirtyScaling === _dirtyScaling
    }
  }
}
